<!--
 * @Author: your name
 * @Date: 2021-04-01 16:18:32
 * @LastEditTime: 2022-11-08 15:43:51
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/AddressInput/index.vue
-->
<style scoped lang="sass">
.mu-input
  width: 100%
  font-size: 20PX
  margin-bottom: 0
  padding-top: 0
  padding-bottom: 0
  min-height: 0

::v-deep
  .mu-text-field
    padding: 0 16PX
    border: 1PX solid rgba(51, 68, 85, 0.1)
    border-radius: 4PX
    background: #FFFFFF

  .mu-input-label
    top: 0 !important
    left: 16PX
    line-height: 0

  .float
    transform: translate3d(0, 26PX, 0) scale(1) !important

  // Hide default bottom border
  // 隐藏默认的下边框
  .mu-input-line,
  .mu-input-focus-line
    display: none

  // Input box text color
  // 输入框内文字的颜色
  .mu-text-field-input
    height: 50PX
    color: #334455
    caret-color: #10CFC9

// .input__focus Get focus status
// .input__focus 获取焦点时的状态
// .no-empty-state Value status in the input box
// .no-empty-state 输入框内有值时的状态
.mu-input__focus,
.no-empty-state
  color: #334455

  ::v-deep
    .mu-input-label
      margin-top: -2PX
      padding: 4PX
      background: #fff
      opacity: .9

.mu-input__focus
  ::v-deep
    .mu-text-field
      border: 1PX solid #10CFC9
</style>

<template>
  <mu-text-field
    id="form_address"
    v-on="$listeners"
    v-bind="$attrs"
    label-float
  />
</template>

<script>
import {
  mapState,
} from 'vuex'
export default {
  props: {
    address: String,
    oldRawAddress: String,
    oldAddress: String,
    oldPostcode: String,
    postcode: [String, Number],
    rawAddress: [String, Object],
  },

  data() {
    return {
      addressAutoComplete: null,
    }
  },
  computed: {
    ...mapState({
      venueCountry: state => state.venueHome.venueCountry || 'au',
    })
  },

  mounted() {
    this.addressAutoComplete = new window.google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */
      (document.querySelector('#form_address')),
      {
        types: ['geocode'],
        componentRestrictions: { country: this.venueCountry }
      }
    )

    this.addressAutoComplete.addListener('place_changed', this.fillInAddress)
  },

  destroyed() {
    if (this.addressAutoComplete) {
      this.addressAutoComplete.unbindAll()
    }
  },

  methods: {
    fillInAddress() {
      const rawAddress = this.addressAutoComplete.getPlace()
      this.$emit('update:rawAddress', JSON.stringify(rawAddress))
      const { address_components, formatted_address } = rawAddress
      let postcode = 'null'
      address_components.forEach(address => {
        if (address.types && address.types.includes('postal_code')) {
          postcode = address.short_name
        }
      })

      this.$emit('update:postcode', postcode)
      this.$emit('update:oldRawAddress', JSON.stringify(rawAddress))
      this.$emit('update:oldAddress', formatted_address)
      this.$emit('update:oldPostcode', postcode)
      this.$emit('update:address', formatted_address)
      this.$emit('submitUserAddress')
    },
  },
}
</script>
